import classNames from 'classnames'
import React from 'react'
import { Link } from '@pandiafi/design-system'

export type SidebarInfoSectionLinkProps =
  React.AnchorHTMLAttributes<HTMLAnchorElement> &
    Pick<React.ComponentProps<typeof Link>, 'href' | 'children'>

export const SidebarInfoSectionLink: React.FC<SidebarInfoSectionLinkProps> = ({
  className,
  ...props
}) => {
  return (
    <Link
      {...props}
      className={classNames(
        'block text-lg leading-6 text-brand-6 underline hover:text-brand-7',
        className
      )}
    />
  )
}
